import * as assert from 'assert';
import { Family, INewFamily } from '../_interfaces/Family';
import { CrudService } from './CrudService';

export class FamilyService extends CrudService<Family, INewFamily, Partial<INewFamily>> {
    protected basePath = 'family';
    protected subPaths = {
        collections: 'collections',
        acceptInvite: 'acceptInvite',
        invite: 'invite'
    };

    public create(newRecord: INewFamily): Promise<number> {
        console.assert(newRecord, 'Paramater is undefined');

        return this.postRequest(newRecord).then((response) => {
            return response.id;
        });
    }

    public getCollectionIdsByFamilyId(family_id: number): Promise<any> {
        console.assert(family_id, 'Paramater is undefined');

        return this.getSubPath(family_id.toString() + '/' + this.subPaths.collections).then((response: any) => {
            assert(Array.isArray(response), 'unexpected response format from server');
            if (response.length > 0) {
                assert(typeof response[0] === 'number', 'unexpected response format from server');
            }
            return response;
        });
    }

    public acceptInvite(invite_key: string): Promise<void> {
        console.assert(invite_key, 'Paramater is undefined');
        return this.postSubPath(this.subPaths.acceptInvite, { invite_key }).then(() => {
            return;
        });
    }

    public sendInvite(email: string, family_id: number): Promise<void> {
        console.assert(email, 'Paramater is undefined');
        console.assert(family_id, 'Paramater is undefined');

        return this.postSubPath(`${family_id}/${this.subPaths.invite}`, { email });
    }

    public addFamilyToCollection(collection_id: number, family_id: number): Promise<any> {
        return this.postSubPath(`${family_id}/${this.subPaths.collections}`, { collection_id });
    }

    public removeFamilyFromCollection(collection_id: number, family_id: number): Promise<any> {
        return this.postSubPath(`${family_id}/${this.subPaths.collections}`, { collection_id });
    }

    public removeUser(userID: number, familyID: number): Promise<any> {
        return this.deleteSubPath(`${familyID}/users`, { target_user_id: userID });
    }

    protected assembleInstances(response: Array<any>): Array<Family> {
        const out: Array<Family> = [];

        response.forEach((record) => {
            const validFamily: Family = this.assembleSingleInstance(record);
            out.push(validFamily);
        });

        return out;
    }

    protected assembleSingleInstance(response: any): Family {
        return new Family(response);
    }
}



// WEBPACK FOOTER //
// ./src/_services/FamilyService.ts